import { fetchJSON } from "./client";

/* presign 발급 */
export async function presignUpload({ filename, size, contentType }) {
  // POST /api/uploads/presign
  return await fetchJSON("/api/uploads/presign", {
    method: "POST",
    body: { filename, size, contentType },
  });
}

/* S3로 실제 업로드 (PUT presigned URL) */
export async function putToS3({ uploadUrl, file }) {
  const res = await fetch(uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": file.type || "application/octet-stream" },
    body: file,
  });
  if (!res.ok) throw new Error(`S3 upload failed with ${res.status}`);
  return true;
}
